import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import useVenues from './useVenues';

const useSortedVenues = (query = null) => {
    const intl = useIntl();
    const venueQuery = useMemo(() => ({ query: { has_future_events: true, ...query } }), [query]);
    const { data: venues = null } = useVenues(venueQuery);

    const finalVenues = useMemo(() => {
        if (venues === null) {
            return null;
        }
        return [
            {
                label: intl.formatMessage({
                    defaultMessage: 'Select a venue',
                    description: 'Select label ',
                }),
                value: '',
            },
        ].concat(
            venues
                .map((venue) => ({
                    value: venue.id,
                    label: venue?.nameWithCity,
                }))
                .sort((a, b) => {
                    if (a.label < b.label) {
                        return -1;
                    }
                    if (a.label > b.label) {
                        return 1;
                    }
                    return 0;
                }),
        );
    }, [venues]);

    return finalVenues;
};

export default useSortedVenues;
